import Api from '@/services/Api';

export default {
    createChecklist(dati) {
        return Api().post('/pratica/checklist/', dati);
    },

    updateChecklist(dati, id) {
        return Api().put('/pratica/checklist/' + id, dati);
    },

    getDatiChecklist(id){
        return Api().get('/pratica/checklist/' + id);
    },

    inviaEmail(dati){
        return Api().post('/pratica/checklist/sendmail', dati);
    }
}